import { Component, ChangeDetectionStrategy, input, output, signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-delete-account-modal',
  imports: [FormsModule],
  templateUrl: './delete-account-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAccountModal {
  readonly busy = input(false);
  readonly error = input<string | null>(null);
  /**
   * False for social-only users, who have no password to confirm with. Deletion
   * then relies on better-auth's fresh-session rule instead.
   */
  readonly requirePassword = input(true);

  readonly cancelled = output<void>();
  /** Emits the password typed by the user, or '' when none is required. */
  readonly confirmed = output<string>();

  protected readonly understood = signal(false);
  protected readonly password = signal('');

  protected readonly canDelete = computed(
    () =>
      this.understood() &&
      (!this.requirePassword() || this.password().length > 0) &&
      !this.busy(),
  );

  protected cancel(): void {
    if (this.busy()) return;
    this.cancelled.emit();
  }

  protected confirm(): void {
    if (!this.canDelete()) return;
    this.confirmed.emit(this.password());
  }
}
